import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    sortBy:['all'],
    onlineConsult: false,
    hospitalVisit: false,
  },
  filterMenu: {
    experience: [],
    fees: [],
    gender: [],
    language: [],
  },
};

const doctorFilterSlice = createSlice({
  name: "doctorFilter",
  initialState,
  reducers: {
    FiltersSet: (state, action) => {
      state.filters = action.payload;
    },
    FilterMenuSet: (state, action) => {
      state.filterMenu = action.payload;
    },
    ClearFiltersSet:(state) => {      
      state.filters = initialState.filters;
    },
  },
});
export const { FiltersSet, FilterMenuSet,ClearFiltersSet } = doctorFilterSlice.actions;
export default doctorFilterSlice.reducer;

